import { render, staticRenderFns } from "./Exchangeinfo.vue?vue&type=template&id=550688ce&scoped=true&"
import script from "./Exchangeinfo.vue?vue&type=script&lang=js&"
export * from "./Exchangeinfo.vue?vue&type=script&lang=js&"
import style0 from "./Exchangeinfo.vue?vue&type=style&index=0&id=550688ce&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550688ce",
  null
  
)

export default component.exports